import React, { Component } from 'react';

import ReduxConnect from 'Demora/redux-connect';

import classNames from 'classnames';

import socialHttp from '../../../../utils/socialHttp';

import {
	Dropdown,
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
} from 'reactstrap';

import './FollowButton.scss';

class FollowButton extends Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			dropdownOpen: false,
			saving: false,
		};
	}

	componentWillUnmount() {
		this.unmounted = true;
	}

	follow = () => {
		let props = this.props;

		let userR = this.getUserR();

		let method = userR.fing ? 'delete' : 'post';

		this.changeFollowInStore(props.obj, !userR.fing, false);

		this.setState({
			saving: true,
			dropdownOpen: false,
		});

		socialHttp(method, '/data/relationships/' + props.obj)
			.then((data) => {
				if (!this.unmounted) {
					let s = {
						saving: false,
					};

					if (!this.getUserR().fing) {
						s.dropdownOpen = false;
					}

					this.setState(s);
				}
			})
			.catch((error) => {
				this.changeFollowInStore(props.obj, !userR.fing);
			});
	};

	favorite = () => {
		let props = this.props;

		let userR = this.getUserR();

		let method = userR.fav ? 'delete' : 'post';

		this.changeFollowInStore(props.obj, !userR.fing, !userR.fav);

		this.setState({
			saving: true,
			dropdownOpen: false,
		});

		socialHttp(method, '/data/relationships/' + props.obj + '/favorite')
			.then((data) => {
				if (!this.unmounted) {
					this.setState({
						saving: false,
					});
				}
			})
			.catch((error) => {
				this.changeFollowInStore(props.obj, !userR.fing, !userR.fav);
			});
	};

	changeFollowInStore(obj, follow, favorite) {
		let users = {};

		users[obj] = {
			r: {
				fing: follow,
				fav: favorite,
			},
		};

		this.props.dispatch({
			type: 'STORE_FEED',
			data: {
				users: users,
			},
		});
	}

	clickOnDropDown = () => {
		let userR = this.getUserR();

		if (!userR.fing && !this.state.dropdownOpen) {
			this.follow();
		} else {
			this.setState({
				dropdownOpen: !this.state.dropdownOpen,
			});
		}
	};

	onMouseEnter = () => {
		let userR = this.getUserR();

		if (!userR.fing) {
			return;
		}

		this.setState({
			dropdownOpen: true,
		});
	};

	onMouseLeave = () => {
		let userR = this.getUserR();

		if (!userR.fing) {
			return;
		}

		this.setState({
			dropdownOpen: false,
		});
	};

	getUserR = () => {
		let props = this.props;

		let user = props.users[props.obj];

		return user.r;
	};

	render() {
		let state = this.state;

		let props = this.props;

		if (!props.user || props.user.id + '-u' == props.obj) {
			return null;
		}

		let user = props.users[props.obj];

		let userR = this.getUserR();

		return (
			<span>
				<Dropdown
					className='follow_button'
					isOpen={state.dropdownOpen}
					onMouseEnter={this.onMouseEnter}
					onMouseLeave={this.onMouseLeave}
					toggle={this.clickOnDropDown}
				>
					<DropdownToggle
						tag='button'
						className={classNames('btn btn-primary', props.className)}
						disabled={state.saving}
					>
						<span
							className='d-none d-sm-inline-block'
							style={{ minWidth: '100px' }}
						>
							{!userR.fing ? (
								'Follow'
							) : !userR.fav ? (
								<span>
									<i className='fas fa-check mr-2' />
									Following
								</span>
							) : (
								<span>
									<i className='fas fa-star mr-2' />
									Favorite
								</span>
							)}
						</span>

						<span className='d-sm-none' style={{ minWidth: '115px' }}>
							{!userR.fing ? (
								<i className='fa fa-user-plus' />
							) : !userR.fav ? (
								<i className='fas fa-user-check' />
							) : (
								<i className='fas fa-star' />
							)}
						</span>
					</DropdownToggle>

					<DropdownMenu right>
						<DropdownItem onClick={this.favorite} disabled={state.saving}>
							{userR.fav ? (
								<i className='fas fa-check mr-2' />
							) : (
								<span style={{ width: '16px' }} className='mr-2 d-inline-block'>
									&nbsp;
								</span>
							)}
							Favorite
						</DropdownItem>
						<DropdownItem onClick={this.follow} disabled={state.saving}>
							<span style={{ width: '16px' }} className='mr-2 d-inline-block'>
								&nbsp;
							</span>
							Unfollow
						</DropdownItem>
					</DropdownMenu>
				</Dropdown>
			</span>
		);
	}
}

export default ReduxConnect(FollowButton, {
	user: 'user',
	feed: 'feed',
	users: 'users',
});
